import { DosFS } from "js-dos/dist/typescript/js-dos-fs";

import { debounce } from "../utils";

export function detectFileChange(
  fs: DosFS,
  files: string[],
  handler: (file: string) => any
) {
  files.forEach((path) => {
    let lastModified = null as number | null;
    const debouncedHandler = debounce(handler, 350);
    setInterval(() => {
      try {
        const modified = (fs as any).fs.stat(path).mtime.getTime() as number;
        if (lastModified !== modified) {
          if (lastModified) {
            debouncedHandler(path);
          }
          lastModified = modified;
        }
      } catch (e) {
        lastModified = -1;
      }
    }, 300);
  });
}
